import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { Modal, Button, Alert } from 'react-bootstrap';
import is from 'is_js';
import * as moment from 'moment';
import * as settings from '../globals/settings'
import * as digitalIdApi from '../api/digitalIdApi'
import Footer from '../components/footer'
import ReactGA from 'react-ga';
import HelpInfo from '../components/helpInfo'
import firstname from '../images/firstname.png';
import lastname from '../images/lastname.png';
import DOB from '../images/DOB.png';
import PHIN from '../images/PHIN.png';
import REG from '../images/REG.png';
import firstnameFR from '../images/firstnameFR.png';
import lastnameFR from '../images/lastnameFR.png';
import DOBFR from '../images/DOBFR.png';
import PHINFR from '../images/PHINFR.png';
import REGFR from '../images/REGFR.png';
import { LANG_EN } from '../util/language_v3';
import {
    INVALID_ITEM_EXCEPTION_CODE, INVALID_PASSWORD_EXCEPTION_CODE,
    CREATE_USER_EXCEPTION_CODE, USERNAME_EXISTS_EXCEPTION_CODE,
    UNKNOWN_ERROR_CODE
} from '../api/vsApi';
import BirthdatePicker from '../components/birthdatePicker';

import {
    validatePassword, validateDateOfBirth, validateMedicareNumber,
    validatePhoneNumber, validateEmail, validateRegNumber,
    validateDay, validateMonth, validateYear, validateUsername,
    validateUsernameChars
} from '../util/validation'
import { doRegister, setFakeLoginState, fakeAuth } from '../actions/auth'
import Loading from '../components/loading'

// FIXME Remove
import { fakeUser, fakeLabResults } from '../util/fakeData'
import { setUser, receiveLabResults, setErrorState, createDeviceId } from '../actions/api'

import NavBar from '../components/navbar'
import '../css/styles.css';

class RegisterScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRegisterError: false,
            errCode: null,
            registerErrorMessage: null,
            username: null,
            password: null,
            confirmPassword: null,
            firstName: null,
            lastName: null,
            dateOfBirth: null,
            medicareNumber: null,
            regNumber: null,
            emailAddress: null,
            confirmEmail: null,
            phoneNumber: '',
            showModal: false,
            hasAccepted: true,
            disableBttn: true,
            validCheck: {
                username: false,
                password: false,
                confirmPassword: false,
                dateOfBirth: false,
                medicareNumber: false,
                phoneNumber: false,
                email: false,
                confirmEmail: false,
                regNumber: false,
            },
            errors: {
                username: null,
                password: null,
                confirmPassword: null,
                dateOfBirth: null,
                medicareNumber: null,
                phoneNumber: null,
                email: null,
                confirmEmail: null,
                gender: null,
                regNumber: null
            },
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.strings !== prevProps.strings && prevState.errCode === this.state.errCode && prevState.errCode !== null){
            if(this.state.errCode === INVALID_ITEM_EXCEPTION_CODE){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM});
            } else if(this.state.errCode === INVALID_PASSWORD_EXCEPTION_CODE){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD});
            } else if(this.state.errCode === CREATE_USER_EXCEPTION_CODE){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_CREATE_USER});
            } else if(this.state.errCode === USERNAME_EXISTS_EXCEPTION_CODE){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.USUERNAME_EXISTS_ERROR_MESSAGE});
            } else if(this.state.errCode === UNKNOWN_ERROR_CODE) {
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE});
            }
        }
    }

    handleScroll(){
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    handleUsernameBlur = (e) => {
        let err = this.state.errors;
        err.username = null;
        let val = e.target.value.trim();
        if(validateUsername(val)){
            if (validateUsernameChars(val)){
                this.setState({username: val, errors: err, validCheck: {...this.state.validCheck, username: true}});
            } else {
                err.username = this.props.strings.REG_ERROR_INVALID_USERNAME_CHAR;
                this.setState({username: val, errors: err, validCheck: {...this.state.validCheck, username: false}});
            }
        } else {
            if (!validateUsernameChars(val)){
                err.username = this.props.strings.REG_ERROR_INVALID_USERNAME_CHAR;
                this.setState({username: val, errors: err, validCheck: {...this.state.validCheck, username: false}});
            } else{
                err.username = this.props.strings.REG_ERROR_INVALID_USERNAME;
                this.setState({username: val, errors: err, validCheck: {...this.state.validCheck, username: false}});
            }
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handlePasswordChange = (e) => {
        let err = this.state.errors;
        err.password = null;
        let val = e.target.value.trim();
        if (validatePassword(e.target.value)) {
            this.setState({password: val, errors: err, validCheck: {...this.state.validCheck, password: true}});
        } else {
            err.password = this.props.strings.REG_ERROR_INVALID_PASSWORD;
            this.setState({password: e.target.value, errors: err, validCheck: {...this.state.validCheck, password: false}});
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleConfirmPasswordChange = (e) => {
        let err = this.state.errors;
        err.confirmPassword = null;
        let val = e.target.value.trim();
        if (this.state.password !== val) {
            err.confirmPassword = this.props.strings.REG_ERROR_PASSWORD_MISMATCH;
            this.setState({confirmPassword: val, errors: err, validCheck: {...this.state.validCheck, confirmPassword: false}});
        } else {
            this.setState({confirmPassword: e.target.value, errors: err, validCheck: {...this.state.validCheck, confirmPassword: true}});
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleFirstNameChange = (e) => {
        this.setState({firstName: e.target.value.trim()});
    }

    handleLastNameChange = (e) => {
        this.setState({lastName: e.target.value.trim()});
    }

    handleDOB = (date) => {
        let err = this.state.errors;
        err.dateOfBirth = null;

        // Parsing date object to create valid dob
        let day = (''+date.getDate()).padStart(2, '0');
        let month = (''+(date.getMonth()+1)).padStart(2, '0');
        let year = date.getFullYear();
        let dob = year + "-" + month + "-" + day;
        console.log("DOB",dob);
        if (validateDateOfBirth(dob)) {
            this.setState({dateOfBirth: dob, errors: err, validCheck: {...this.state.validCheck, dateOfBirth: true}});
        } else {
            err.dateOfBirth = this.props.strings.REG_ERROR_INVALID_DOB;
            this.setState({dateOfBirth: dob, errors: err, validCheck: {...this.state.validCheck, dateOfBirth: false}});
        }

        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleMedicareNumberChange = (e) => {
        let err = this.state.errors;
        err.medicareNumber = null;
        if (e.currentTarget.value.includes(" ")) {
            e.currentTarget.value = e.currentTarget.value.replace(/\s/g, "");
        }
        let val = e.target.value.trim();
        if (validateMedicareNumber(val)) {
            this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: true}});
        } else {
            err.medicareNumber = this.props.strings.REG_ERROR_INVALID_MEDICARE_NUMBER;
            this.setState({medicareNumber: e.target.value, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleMedicareNumberBlur = (e) => {
        let err = this.state.errors;
        err.medicareNumber = null;
        if (e.currentTarget.value.includes(" ")) {
            e.currentTarget.value = e.currentTarget.value.replace(/\s/g, "");
        }
        let val = e.target.value.trim();
        if (val.length === 9) {
            this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: true}});
        } else {
            err.medicareNumber = this.props.strings.REG_ERROR_INVALID_MEDICARE_NUMBER;
            this.setState({medicareNumber: e.target.value, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
        }
    }

    handleRegNumberChange  = (e) => {
        const err = this.state.errors;
        const regNum = e.target.value.trim().toUpperCase();
        const validRegNum = validateRegNumber(regNum);
        err.regNumber = validRegNum ? null : this.props.strings.REG_ERROR_INVALID_REG_NUMBER;
        this.setState({ regNumber: regNum , errors: err, validCheck: { ...this.state.validCheck, regNum: validRegNum }});

        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleRegNumberBlur  = (e) => {
        let err = this.state.errors;
        err.regNumber = null;
        if(e.target.value.trim() === null || e.target.value.trim() === undefined || e.target.value.trim() === ''){
            err.regNumber = this.props.strings.REG_ERROR_INVALID_REG_NUMBER;
            this.setState({regNumber: e.target.value, errors: err, validCheck: {...this.state.validCheck, regNumber: false}});
        } else {
            let val = e.target.value.padStart(6, '0').trim();
            if (validateRegNumber(val)) {
                this.setState({regNumber: val, errors: err, validCheck: {...this.state.validCheck, regNumber: true}});
            } else {
                err.regNumber = this.props.strings.REG_ERROR_INVALID_REG_NUMBER;
                this.setState({regNumber: e.target.value, errors: err, validCheck: {...this.state.validCheck, regNumber: false}});
            }
        }

        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleEmailAddressChange = (e) => {
        let err = this.state.errors;
        err.email = null;
        let val = e.target.value.trim();
        if (validateEmail(val)) {
            this.setState({emailAddress: val, errors: err, validCheck: {...this.state.validCheck, email: true}});
        } else {
            err.email = this.props.strings.REG_ERROR_INVALID_EMAIL;
            this.setState({emailAddress: e.target.value, errors: err, validCheck: {...this.state.validCheck, email: false}});
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleConfirmEmailAddressChange = (e) => {
        let err = this.state.errors;
        err.confirmEmail = null;
        let val = e.target.value.trim();
        if (this.state.emailAddress !== val) {
            err.confirmEmail = this.props.strings.REG_ERROR_EMAIL_MISMATCH;
            this.setState({confirmEmail: val, errors: err, validCheck: {...this.state.validCheck, confirmEmail: false}});
        } else {
            
            this.setState({confirmEmail: e.target.value, errors: err, validCheck: {...this.state.validCheck, confirmEmail: true}});
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handlePhoneNumberChange = (e) => {
        let err = this.state.errors;
        err.phoneNumber = null;
        let val = e.target.value.trim();
        if (validatePhoneNumber(val)) {
            if(val.length === 10){
                this.setState({phoneNumber: val, errors: err, validCheck: {...this.state.validCheck, phoneNumber: true}});
            } else {
                this.setState({phoneNumber: val, errors: err, validCheck: {...this.state.validCheck, phoneNumber: false}});
            }
        } else if(val === null || val === undefined || val === ''){
            err.phoneNumber = this.props.strings.REG_ERROR_INVALID_PHONE_NUMBER;
            this.setState({phoneNumber: val, errors: err, validCheck: {...this.state.validCheck, phoneNumber: false}});
        } else {
            if (!validatePhoneNumber(val)) { return; }
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handlePhoneNumberBlur = (e) => {
        let err = this.state.errors;
        err.phoneNumber = null;
        let val = e.target.value.trim();
        if(val === null || val === "" || val === undefined){
            err.phoneNumber = this.props.strings.REG_ERROR_INVALID_PHONE_NUMBER;
            this.setState({phoneNumber: val, errors: err, validCheck: {...this.state.validCheck, phoneNumber: false}});
        }
        else if(!validatePhoneNumber(val)){
            err.phoneNumber = this.props.strings.REG_ERROR_INVALID_PHONE_NUMBER;
            this.setState({phoneNumber: val, errors: err, validCheck: {...this.state.validCheck, phoneNumber: false}});
        }
        else if(val.length !== 10){
            err.phoneNumber = this.props.strings.REG_ERROR_INVALID_PHONE_NUMBER;
            this.setState({phoneNumber: val, errors: err, validCheck: {...this.state.validCheck, phoneNumber: false}});
        }
        if(!this.state.hasAccepted){
            this.checkVals()
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({isRegisterError: false, registerErrorMessage: null});
        let dto = this.makeRegDto();
        let resp = this.props.dispatch(doRegister(dto))
            .then(() => {
                setTimeout(() => {
                    this.props.history.push("/successful_register");
                }, 500);
            })
            .catch(err => {
                // FIXME Handle errors here!
                this.setState({disableBttn: true});
                this.setState({ hasAccepted: true });
                if(err.code === INVALID_ITEM_EXCEPTION_CODE){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM, errCode: err.code});
                } else if(err.code === INVALID_PASSWORD_EXCEPTION_CODE){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD, errCode: err.code});
                } else if(err.code === CREATE_USER_EXCEPTION_CODE){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_CREATE_USER, errCode: err.code});
                } else if(err.code === USERNAME_EXISTS_EXCEPTION_CODE){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.USUERNAME_EXISTS_ERROR_MESSAGE, errCode: err.code});
                } else {
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE, errCode: err.code});
                }
                // Scroll to top so user can see error message
                this.handleScroll();
            });;

        // Capturing Google Analytics
        ReactGA.event({
            category: 'Registration event',
            action: 'Registration Success',
            label: 'registration-success'
        });
    }

    handleCancel = (e) => {
        e.preventDefault();
        this.props.history.push("/");
    }

    // FIXME Not sure what should go here?
    renderError(key) {
        if (this.state.errors[key])  {
            return (
                <div className="invalid-feedback">{this.state.errors[key]}</div>
            );
        } else {
            return null;
        }
    }

    renderErrorClass(key) {
        let c = "form-control";
        if (this.state.errors[key])  {
            c = "form-control is-invalid";
        }
        return c;
    }

    renderRegisterError() {
        if (this.state.isRegisterError === false || this.state.registerErrorMessage === null) {
            return null;
        } else if(this.state.errCode === UNKNOWN_ERROR_CODE){
            return (
                <div>
                    <div class="alert alert-danger" role="alert">
                        <p>{this.props.strings.REGISTER_ERROR_MESSAGE}</p>
                        <ol>
                            <li>
                                {this.props.strings.REGISTER_ERROR_INFO_1_0}<a href={`mailto:${this.props.strings.NO_REPLY_EMAIL}`}>{this.props.strings.NO_REPLY_EMAIL}</a>{this.props.strings.REGISTER_ERROR_INFO_1_0_0}
                                {this.props.strings.REGISTER_ERROR_INFO_1_1}<a className="forget-label" href={`/manitoba/usernameRequest?lang=${this.props.language}`}>{this.props.strings.REGISTER_ERROR_INFO_1_2}</a>
                                {this.props.strings.REGISTER_ERROR_INFO_1_3}
                                <a className="forget-label" href={`/manitoba/resetPasswordRequest?lang=${this.props.language}`}>{this.props.strings.REGISTER_ERROR_INFO_1_4}</a>{this.props.strings.REGISTER_ERROR_INFO_1_5}
                            </li>
                            <li>{this.props.strings.REGISTER_ERROR_INFO_2}</li>
                        </ol>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <span style={{color: 'red', fontWeight: 'bold'}}>Error: {this.state.registerErrorMessage}</span>
                </div>
            );
        }
    }

    renderDateError(){
        if(this.state.errors.dateOfBirth !== null){
            return <div className="dobErrorMsg">{this.state.errors['dateOfBirth']}</div>;
        } else{
            return null;
        }
    }

    makeRegDto() {
        let obj = {
            userName: this.state.username,
            password: this.state.password,
            confirmPassword: this.state.confirmPassword,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            dateOfBirth: this.state.dateOfBirth,
            medicareNumber: this.state.medicareNumber,
            emailAddress: this.state.emailAddress,
            postalCode: "A1A 1A1",
            phoneNumber: this.state.phoneNumber,
            mbRegNumber: this.state.regNumber
        };
        return obj;
    }

    validate(dto) {
        let error = null;
        // Check required fields..
        // All fields are required right now.
        Object.entries(dto).forEach((o) => {
            if (o == null) {
                error = this.props.strings.MISSING_REQUIRED_FIELDS;
            }
        });

        // Check for errors.
        Object.entries(this.state.errors).forEach((e) => {
            if (e[1] !== null) {
                error = e;
            }
        });
        return error;
    }

    checkVals = () => {
        let allValid = Object.keys(this.state.validCheck).every((e) => this.state.validCheck[e]);
        console.log(allValid);
        if(allValid && this.state.hasAccepted){
            this.setState({disableBttn: false}); // Disable button === false
        } else{
            this.setState({disableBttn: true}); // Disable button === true
        }
        this.setState({ hasAccepted: !this.state.hasAccepted });
        return this.state.hasAccepted;
    }

    renderLoadingModal(){
        if (this.props.isLoadingRegister === true) {
            return (
                <Modal
                    size="lg"
                    show={true}
                    centered={true}
                    scrollable={true}
                    onHide={false}
                >
                    <Modal.Body>
                        <Loading />
                    </Modal.Body>
                </Modal>
            );
        } else {
            return null;
        }
    }

    setExampleImages=(language)=>{
        let exampleImages = {
            FIRST_NAME_EXAMPLE: "",
            LAST_NAME_EXAMPLE: "",
            DOB_EXAMPLE: "",
            PHIN_EXAMPLE: "",
            REG_EXAMPLE: "",
        }
        if (language === LANG_EN){
            exampleImages.FIRST_NAME_EXAMPLE = firstname;
            exampleImages.LAST_NAME_EXAMPLE = lastname;
            exampleImages.DOB_EXAMPLE = DOB;
            exampleImages.PHIN_EXAMPLE =  PHIN;
            exampleImages.REG_EXAMPLE = REG;
        }
        else{
            exampleImages.FIRST_NAME_EXAMPLE = firstnameFR;
            exampleImages.LAST_NAME_EXAMPLE = lastnameFR;
            exampleImages.DOB_EXAMPLE = DOBFR;
            exampleImages.PHIN_EXAMPLE =  PHINFR;
            exampleImages.REG_EXAMPLE = REGFR;
        }
        return exampleImages;
    }

    render() {
        let startDate = new Date();
        if (this.props.isError === true) {
            return <Redirect to="error" />
        } //else if (this.props.isLoadingRegister === true) {
            // return <Loading />;
        // }
        let exampleImages  = this.setExampleImages(this.props.language);
        return (
          <div className="container-full">
            <NavBar language={this.props.language}/>
            <div className="container justify-content-center align-items-center">

                <div class="alert alert-info" role="alert">
                    <h5>{this.props.strings.REGISTER_LABEL}</h5>
                    <p>
                        {this.props.strings.REGISTER_PAGE_TITLE}
                        <Link to="login"> {this.props.strings.LOGIN_NOW_LABEL}</Link>
                    </p>
                    <h7 className="helpForm">{this.props.strings.HELP_FORM_STRING_1}<a target="_blank" href={this.props.strings.HELP_FORM_LINK}>{this.props.strings.HELP_FORM_STRING_2}</a>{this.props.strings.HELP_FORM_STRING_3}
                    </h7>
                </div>
                {this.renderRegisterError()}
                {this.renderLoadingModal()}
                <form onSubmit={this.handleSubmit} className="formMargin">
                    <div class="form-group">
                        <HelpInfo labelName="username-input" helpInfoText={this.props.strings.HELP_FIELD_USERNAME} labelText={this.props.strings.USERNAME_LABEL} />
                        <input class={this.renderErrorClass('username')} id="username-input" placeholder={this.props.strings.USERNAME} onBlur={this.handleUsernameBlur}/>
                        {this.renderError('username')}
                    </div>
                    <div class="form-group">
                        <HelpInfo labelName="password-input" helpInfoText={this.props.strings.HELP_FIELD_PASSWORD} labelText={this.props.strings.PASSWORD_REG_LABEL} />
                        <input class={this.renderErrorClass('password')} type="password" id="password-input" placeholder={this.props.strings.PASSWORD} onBlur={this.handlePasswordChange}/>
                        {this.renderError('password')}
                    </div>
                    <div class="form-group">
                        <label for="confirm-password-input"><b>{this.props.strings.CONFIRM_PASSWORD_LABEL}</b></label>
                        <input class={this.renderErrorClass('confirmPassword')} type="password" id="confirm-password-input" placeholder={this.props.strings.CONFIRM_PASSWORD_LABEL} onBlur={this.handleConfirmPasswordChange}/>
                        {this.renderError('confirmPassword')}
                    </div>
                    <div class="form-group">
                        <HelpInfo labelName="email-input" helpInfoText={this.props.strings.HELP_FIELD_EMAIL} labelText={this.props.strings.EMAIL_LABEL} />
                        <input class={this.renderErrorClass('email')} id="email-input" placeholder={this.props.strings.EMAIL} onBlur={this.handleEmailAddressChange}/>
                        {this.renderError('email')}
                    </div>
                    <div class="form-group">
                        <HelpInfo labelName="confirm-email-input" helpInfoText={this.props.strings.HELP_FIELD_CONFIRM_EMAIL} labelText={this.props.strings.CONFIRM_EMAIL_LABEL}/>
                        <input class={this.renderErrorClass('confirmEmail')} id="confirm-email-input" placeholder={this.props.strings.CONFIRM_EMAIL} onBlur={this.handleConfirmEmailAddressChange}/>
                        {this.renderError('confirmEmail')}
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-5-5">
                            <HelpInfo labelName="phone-input" helpInfoText={this.props.strings.HELP_FIELD_PHONE_NUMBER} labelText={this.props.strings.PHONE_LABEL}/>
                            <input
                                class={this.renderErrorClass('phoneNumber')} id="phone-input" placeholder={this.props.strings.PHONE}
                                onChange={this.handlePhoneNumberChange} onBlur={this.handlePhoneNumberBlur} value={this.state.phoneNumber}
                            />
                            {this.renderError('phoneNumber')}
                        </div>
                    </div>
                    <hr />
                    <div class="form-group">
                        <label for="first-name-input"><b>{this.props.strings.FIRST_NAME_LABEL}</b></label>
                        <input class="form-control" id="first-name-input" placeholder={this.props.strings.FIRST_NAME} onBlur={this.handleFirstNameChange}/>
                        <div class="regCard"><img src={exampleImages.FIRST_NAME_EXAMPLE}/></div>
                    </div>
                    <hr />
                    <div class="form-group">
                        <label for="last-name-input"><b>{this.props.strings.LAST_NAME_LABEL}</b></label>
                        <input class="form-control" id="last-name-input" placeholder={this.props.strings.LAST_NAME} onBlur={this.handleLastNameChange}/>
                        <div class="regCard"><img src={exampleImages.LAST_NAME_EXAMPLE}/></div>
                    </div>
                    <hr />
                    <div class="form-group">
                        <label for="dob-input"><b>{this.props.strings.DOB_LABEL}</b></label><br/>
                        <div class="dobPicker"><BirthdatePicker changeDate={this.handleDOB} lang={this.props.language} /></div>
                        {this.renderDateError()}
                        <div class="regCard"><img src={exampleImages.DOB_EXAMPLE}/></div>
                    </div>
                    <hr />
                    <div class="form-group">
                        <HelpInfo labelName="medicare-input" helpInfoText={this.props.strings.HELP_FIELD_MEDICARE} labelText={this.props.strings.MEDICARE_LABEL}/>
                        <input class={this.renderErrorClass('medicareNumber')} id="medicare-input" placeholder={this.props.strings.MEDICARE} onBlur={this.handleMedicareNumberBlur} onChange={this.handleMedicareNumberChange} value={this.state.medicareNumber} />
                        {this.renderError('medicareNumber')}
                        <div class="regCard"><img src={exampleImages.PHIN_EXAMPLE}/></div>
                    </div>
                    <hr />
                    <div class="form-group">
                        <HelpInfo labelName="regnum-input" helpInfoText={this.props.strings.HELP_FIELD_REGISTER_NUMBER} labelText={this.props.strings.REGNUM_LABEL} />
                        <input class={this.renderErrorClass('regNumber')} id="regnum-input" placeholder={this.props.strings.REGNUM}
                            onChange={this.handleRegNumberChange} onBlur={this.handleRegNumberBlur} value={this.state.regNumber} maxLength={6}
                        />
                        {this.renderError('regNumber')}
                        <div class="regCard"><img src={exampleImages.REG_EXAMPLE}/></div>
                    </div>
                    <div class="alert-secondary" role="alert">
                        <div class="form-check">
                            <h5 class="text-center">{this.props.strings.TOU}</h5>
                            <p>
                                <h6><b><u>{this.props.strings.TOU_TEXT_2}</u></b></h6>
                                <hr />

                                <p>
                                <p>
                                    {this.props.strings.TOU_TEXT_4_1}
                                    <i>{this.props.strings.TOU_TEXT_4_2}</i>
                                    {this.props.strings.TOU_TEXT_4_3}
                                </p>
                                <p>
                                    {this.props.strings.TOU_TEXT_5_1}
                                    <b>{this.props.strings.TOU_TEXT_5_2}</b>
                                    {this.props.strings.TOU_TEXT_5_3}
                                    <b>{this.props.strings.TOU_TEXT_5_4}</b>.
                                </p>
                                <p>{this.props.strings.TOU_TEXT_6_1}<a href={this.props.strings.PRIVACY_LINK} target='_blank'>{this.props.strings.TOU_TEXT_6_2}</a>{this.props.strings.TOU_TEXT_6_3}<a href={this.props.strings.TOU_URL} target='_blank'>{this.props.strings.TOU_URL}</a></p>
                                </p>

                                <p>
                                <h5><b>{this.props.strings.TOU_TEXT_7}</b></h5>
                                <p>{this.props.strings.TOU_TEXT_8}</p>
                                <ul>
                                    <li>{this.props.strings.TOU_TEXT_9}</li>
                                    <li>{this.props.strings.TOU_TEXT_10}</li>
                                    <li>{this.props.strings.TOU_TEXT_11}</li>
                                    <li>{this.props.strings.TOU_TEXT_12} <i>{this.props.strings.TOU_TEXT_12_1}</i>{this.props.strings.TOU_TEXT_12_2}</li>
                                </ul>
                                </p>

                                <p>
                                <h5><b>{this.props.strings.TOU_TEXT_13}</b></h5>
                                <p>{this.props.strings.TOU_TEXT_14}</p>
                                <ul>
                                    <li>{this.props.strings.TOU_TEXT_15}</li>
                                    <li>{this.props.strings.TOU_TEXT_16}</li>
                                    <li>{this.props.strings.TOU_TEXT_17}</li>
                                    <li>{this.props.strings.TOU_TEXT_18}</li>
                                    <li>{this.props.strings.TOU_TEXT_19}</li>
                                    <li>{this.props.strings.TOU_TEXT_20}</li>
                                    <li>{this.props.strings.TOU_TEXT_21}</li>
                                    <li>{this.props.strings.TOU_TEXT_22}</li>
                                    <li>{this.props.strings.TOU_TEXT_23}</li>
                                </ul>
                                </p>

                                <p>
                                <h5><b>{this.props.strings.TOU_TEXT_24}</b></h5>
                                <p>{this.props.strings.TOU_TEXT_25}</p>
                                <ul>
                                    <li>{this.props.strings.TOU_TEXT_26}</li>
                                    <li>{this.props.strings.TOU_TEXT_27}</li>
                                </ul>
                                </p>

                                <p>
                                <h5><b>{this.props.strings.DISCLAIMER_HEADER}</b></h5>
                                <p>{this.props.strings.DISCLAIMER_CONTENT}</p>
                                </p>

                                <p>
                                <h5><b>{this.props.strings.TOU_TEXT_28}</b></h5>
                                <p>{this.props.strings.TOU_TEXT_29}</p>
                                </p>

                                <p>
                                <h5><b>{this.props.strings.TOU_TEXT_30}</b></h5>
                                <p>{this.props.strings.TOU_TEXT_31}</p>
                                </p>
                            </p>
                            <div class="agreeTOU">
                            <label class="form-check-label" for="defaultCheck">
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck" checked={!this.state.hasAccepted} onClick={() => this.checkVals()}/>
                                {this.props.strings.TOU_AGREE} {this.props.strings.TOU}
                            </label>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <button
                            type="submit"
                            class={ this.state.disableBttn ? "btn btn-secondary custom-button":"btn btn-primary custom-button" }
                            disabled={this.state.disableBttn}
                        >
                            {this.props.strings.REGISTER_BUTTON_LABEL}
                        </button>
                        <button type="button" class="btn btn-secondary custom-button" onClick={this.handleCancel} >{this.props.strings.CANCEL_BUTTON_LABEL}</button>
                    </div>
                </form>
            </div>
            <Footer />
          </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoadingRegister: state.auth.isLoadingRegister,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        strings: state.language.strings,
        isError: state.api.isError,
        language: state.language.language,
    }
}

const ConnectedRegisterScreen = connect(
    mapStateToProps
)(RegisterScreen);

export default withRouter(ConnectedRegisterScreen);